import { d as defineCustomElement } from '../chunks/vidstack-Uw94Yvrg.js';
import { h as MediaLayoutElement, c as MediaControlsElement, d as MediaControlsGroupElement, b as MediaAnnouncerElement, k as MediaTooltipElement, l as MediaTooltipTriggerElement, m as MediaTooltipContentElement, i as MediaGoogleCastButtonElement, j as MediaToggleButtonElement, s as MediaSliderElement, u as MediaAudioGainSliderElement, v as MediaSpeedSliderElement, w as MediaQualitySliderElement, x as MediaSliderChaptersElement, y as MediaSliderStepsElement, t as MediaSliderVideoElement, n as MediaMenuPortalElement, p as MediaAudioGainRadioGroupElement, o as MediaChaptersRadioGroupElement, r as MediaRadioGroupElement, q as MediaRadioElement, a as MediaGestureElement, M as MediaCaptionsElement, e as MediaTitleElement, f as MediaChapterTitleElement, g as MediaSpinnerElement } from '../chunks/vidstack-uewifCxo.js';
import { h as MediaPlayButtonElement, f as MediaMuteButtonElement, c as MediaCaptionButtonElement, d as MediaFullscreenButtonElement, g as MediaPIPButtonElement, i as MediaSeekButtonElement, b as MediaAirPlayButtonElement, v as MediaVolumeSliderElement, t as MediaTimeSliderElement, u as MediaSliderPreviewElement, s as MediaSliderValueElement, r as MediaSliderThumbnailElement, l as MediaMenuElement, m as MediaMenuButtonElement, o as MediaMenuItemsElement, n as MediaMenuItemElement, j as MediaAudioRadioGroupElement, k as MediaCaptionsRadioGroupElement, p as MediaSpeedRadioGroupElement, q as MediaQualityRadioGroupElement, M as MediaThumbnailElement, e as MediaLiveButtonElement, a as MediaTimeElement } from '../chunks/vidstack-DfdxShpD.js';
import { MediaPosterElement } from '../chunks/vidstack-TNK4vPcR.js';
import '../chunks/vidstack-DLpJQ4a5.js';
import '../chunks/vidstack-D73YzvPy.js';
import '../chunks/vidstack-VrKElWm_.js';
import '../chunks/vidstack-BYKVJb7W.js';
import '../chunks/vidstack-DSCDp3Na.js';
import '../chunks/vidstack-69_0Ad1E.js';
import '../chunks/vidstack-ByTY2VS-.js';
import '../chunks/vidstack-Du-_dEIb.js';
import '../chunks/vidstack-BSXZsAhp.js';
import '../chunks/vidstack-BUqeBbTQ.js';
import '../chunks/vidstack-ksPACRiU.js';
import '../chunks/vidstack-CSaHpIQV.js';
import '../chunks/vidstack-Dchp6m-3.js';
import '../chunks/vidstack-B9257nP4.js';
import '../chunks/vidstack-Bf6opHxk.js';
import '../chunks/vidstack-rsZGrNIW.js';
import '../chunks/vidstack-BOhk1sCg.js';

defineCustomElement(MediaLayoutElement);
defineCustomElement(MediaControlsElement);
defineCustomElement(MediaControlsGroupElement);
defineCustomElement(MediaPosterElement);
defineCustomElement(MediaAnnouncerElement);
defineCustomElement(MediaTooltipElement);
defineCustomElement(MediaTooltipTriggerElement);
defineCustomElement(MediaTooltipContentElement);
defineCustomElement(MediaPlayButtonElement);
defineCustomElement(MediaMuteButtonElement);
defineCustomElement(MediaCaptionButtonElement);
defineCustomElement(MediaFullscreenButtonElement);
defineCustomElement(MediaPIPButtonElement);
defineCustomElement(MediaSeekButtonElement);
defineCustomElement(MediaAirPlayButtonElement);
defineCustomElement(MediaGoogleCastButtonElement);
defineCustomElement(MediaToggleButtonElement);
defineCustomElement(MediaSliderElement);
defineCustomElement(MediaAudioGainSliderElement);
defineCustomElement(MediaVolumeSliderElement);
defineCustomElement(MediaTimeSliderElement);
defineCustomElement(MediaSpeedSliderElement);
defineCustomElement(MediaQualitySliderElement);
defineCustomElement(MediaSliderChaptersElement);
defineCustomElement(MediaSliderStepsElement);
defineCustomElement(MediaSliderPreviewElement);
defineCustomElement(MediaSliderValueElement);
defineCustomElement(MediaSliderThumbnailElement);
defineCustomElement(MediaSliderVideoElement);
defineCustomElement(MediaMenuElement);
defineCustomElement(MediaMenuButtonElement);
defineCustomElement(MediaMenuPortalElement);
defineCustomElement(MediaMenuItemsElement);
defineCustomElement(MediaMenuItemElement);
defineCustomElement(MediaAudioRadioGroupElement);
defineCustomElement(MediaCaptionsRadioGroupElement);
defineCustomElement(MediaSpeedRadioGroupElement);
defineCustomElement(MediaAudioGainRadioGroupElement);
defineCustomElement(MediaQualityRadioGroupElement);
defineCustomElement(MediaChaptersRadioGroupElement);
defineCustomElement(MediaRadioGroupElement);
defineCustomElement(MediaRadioElement);
defineCustomElement(MediaGestureElement);
defineCustomElement(MediaThumbnailElement);
defineCustomElement(MediaCaptionsElement);
defineCustomElement(MediaLiveButtonElement);
defineCustomElement(MediaTimeElement);
defineCustomElement(MediaTitleElement);
defineCustomElement(MediaChapterTitleElement);
defineCustomElement(MediaSpinnerElement);
